export default {
	meta(model, ids, cb, ecb) {
		model = model.toLowerCase()
		this.http
			.get(`/${model}/meta/${ids}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getMenu(cb, ecb) {
		this.http.get('/api/getMenu/', {}).then((response) => {
			cb(response)
		})
	},
	getWxSignPackage(url, cb, ecb, config = {}) {
		this.http
			.get('/weixin/getSignPackage/' + encodeURIComponent(url), config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getSettings(names, cb) {
		this.http.get('/api/getSettings/' + names, {}).then((response) => {
			cb(response)
		})
	},
	getMeta(clz, fs, cb) {
		this.http.get(`/${clz}/meta/${fs}`).then((r) => {
			cb(r)
		})
	},
	upconfig(config, cb, ecb) {
		this.http
			.get(`/common/upconfig/${config}`)
			.then((r) => {
				cb && cb(r)
			})
			.catch((e) => {
				ecb && ecb(e)
			})
	}
}
